module.exports = __webpack_public_path__ + "static/classlist-de8b21bb6d29e9da976f44600c8c381b.mp4";